import type {
    BookableSettings_V2} from "@@/shared/acquire/bookable-settings";
import {
    bookableSettingsV2ZodSchema,
} from "@@/shared/acquire/bookable-settings";
import type {
    BookableSessionSeriesId} from "@@/shared/acquire/sessions/bookable-session-series-id";
import {
    bookableSessionSeriesIdZodSchema,
} from "@@/shared/acquire/sessions/bookable-session-series-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { ProductCommandCommon } from "./product-commands-common";

type BookableSeriesChangeSettingCommand = ProductCommandCommon & {
    readonly _id: string;
    readonly _type: "BOOKABLE_SERIES_CHANGE_SETTINGS_COMMAND";
    readonly seriesId: BookableSessionSeriesId;

    readonly bookableSettings: BookableSettings_V2;
};

type CreateParams = Except<
    ProductCommandCommon & BookableSeriesChangeSettingCommand,
    "_id" | "_type" | "_createdAt"
>;
const bookableSeriesSettingCommandFactory = (params: CreateParams) => {
    const editCommand: BookableSeriesChangeSettingCommand = {
        ...params,
        _id: generateId({
            prefix: "bookable_change_duration_command__",
        }),
        _type: "BOOKABLE_SERIES_CHANGE_SETTINGS_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return editCommand;
};

const bookableSeriesChangeSettingCommandZodSchema: z.ZodSchema<BookableSeriesChangeSettingCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("BOOKABLE_SERIES_CHANGE_SETTINGS_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        productId: productIdZodSchema,
        seriesId: bookableSessionSeriesIdZodSchema,
        bookableSettings: bookableSettingsV2ZodSchema,
    });

export {
    bookableSeriesChangeSettingCommandZodSchema,
    bookableSeriesSettingCommandFactory,
};
export type {
    BookableSeriesChangeSettingCommand,
    CreateParams as CreateBookableSeriesChangeSettingCommandParams,
};
